import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import EventImagePreview from "@/components/Events/EventImagePreview/EventImagePreview.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
import { emailRegex } from "@/configuration/formConfigurations";
import { getImageDimensionSizes, getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { uploadFile } from "@/helpers/fileHelper";
import "@/EditDialog.scss";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "KisSubjectAreaEditDialog",
  components: {
    LogOverview,
    EventImagePreview,
    ValidationDialog,
    TreeViewSelection
  },
  props: ["editDialog", "editedItem", "persons", "departments", "tasks"],
  data: () => ({
    step: 1,
    errorList: [],
    errorDialog: false,
    emailRegex,
    preventMainWatch: false,
    mainDragging: false,
    manualSlug: false,
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js"
  }),
  mounted() {},
  methods: {
    close() {
      this.manualSlug = false;
      this.step = 1;
      this.$emit("closeDialog");
    },
    addSecretary(value) {
      if (Array.isArray(value) && !value.length) {
        this.editedItem.secretariat = null;
      } else {
        this.editedItem.secretariat = value;
      }
    },
    addEmployee(value) {
      this.editedItem.employees = value;
    },
    addManagement(value) {
      if (Array.isArray(value) && !value.length) {
        this.editedItem.management = null;
      } else {
        this.editedItem.management = value;
      }
    },
    addParents(value) {
      this.editedItem.parents = value;
    },
    addTasks(value) {
      this.editedItem.tasks = value;
    },
    async save(close = false) {
      if (this.editedItem._id) {
        await this.updateSubjectArea();
      } else {
        await this.createSubjectArea();
      }

      const logsFetched = this.$refs?.logOverview?.logsFetched;
      this.$refs?.logOverview?.resetLogs();

      if (close) {
        this.close();
      } else if (logsFetched) {
        await this.$refs?.logOverview?.getLogs();
      }
    },
    async createSubjectArea() {
      try {
        const headers = getTokenHeader();
        if (!this.editedItem.principal_id)
          this.editedItem.principal_id = this.currentPrincipal;
        const response = await axios.post(
          `${env.kis_api_client_url}subjectarea`,
          this.editedItem,
          {
            headers
          }
        );
        if (response.status === 201) {
          this.$emit("setSubjectArea", response.data);
          await this.$store.dispatch("createSuccess", "Erfolgreich erstellt");
          await this.$store.dispatch("getSubjectAreas", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch(
          "createError",
          "Es ist ein Fehler aufgetreten!"
        );
      }
    },
    async updateSubjectArea() {
      try {
        await this.$emit("updateSubjectArea", this.editedItem);
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    addLink() {
      this.editedItem.links.push({ url: "", title: "" });
    },
    removeLink(index) {
      this.editedItem.links.splice(index, 1);
    },
    userById(id) {
      if (!id) return "";
      const user = this.users.find(u => u.id === id || u._id === id);
      if (user?.first_name && user?.last_name)
        return `${user.first_name} ${user.last_name}`;
      else return null;
    },
    checkValid() {
      const form = this.$refs.subjectAreaEditForm;
      form.validate();
      const invalidFields = form._data.inputs.filter(i => !i.valid);
      this.errorList = [];
      invalidFields.forEach(field => {
        this.errorList.push({
          field: field?.$vnode?.componentOptions?.propsData?.label?.replace(
            "*",
            ""
          ),
          validations: field.validations
        });
      });
      if (this.errorList.length) this.errorDialog = true;

      if (this.errorList.length === 0) {
        return true;
      }
      return false;
    },
    async addDropFile(e, type, isImage = true) {
      if (!Array.isArray(this[`${type}Files`])) this[`${type}Files`] = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("bucket", "kis");

        const data = await uploadFile(
          file,
          this.editedItem.id || this.editedItem._id,
          "kis",
          this.currentPrincipal,
          progressEvent => {
            this.$store.dispatch(
              "createSuccess",
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );

        if (!data?.image_sizes && data.url && isImage) {
          data.image_sizes = await getImageDimensionSizes(data.url);
        }
        data.principal_id = this.currentPrincipal;

        data.title = file.name;
        data.id = data._id;
        file = { ...file, ...data };

        if (!this.editedItem.pictures) this.editedItem.pictures = [];
        this.editedItem.pictures.push(data);
        await this.save(false);
      });
    },
    setMainFiles(newVal) {
      const order = newVal.map(v => v.id);
      this.preventMainWatch = true;
      this.mainFiles = _.sortBy(this.mainFiles, file => {
        return _.indexOf(order, file.id);
      });
    },
    readFileUrls(files, type) {
      this[`${type}Dragging`] = false;
      this[`${type}Files`].forEach(file => {
        if (!file.id) {
          const reader = new FileReader();
          reader.onload = event => {
            const target = event.target;
            if (target?.result) {
              file.originalUrl = target.result;
              file.dataUrl = target.result;
            }
          };
          reader.readAsDataURL(file);
        }
      });
    },
    async removeFile(id, type) {
      this.$emit("addToDestroyList", id);
      const index = this[`${type}Files`].findIndex(f => f.url.includes(id));
      this[`${type}Files`].splice(index, 1);
    }
  },
  computed: {
    mainFiles: {
      get() {
        return this.editedItem?.pictures ?? [];
      },
      set(value) {
        this.editedEvent.pictures = value;
      }
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    users() {
      return this.$store.state.users;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    logUrl() {
      return `${env.kis_api_client_url}log/${this.editedItem._id}`;
    }
  },
  watch: {
    mainFiles(val) {
      if (!this.preventMainWatch) {
        this.readFileUrls(val, "main");
      } else this.preventMainWatch = false;
    }
  }
};
